import type { IApiPerson, IPerson } from 'src/interfaces';

export const mapApiToPerson = ({ firstname, lastname, ...rest }: IApiPerson): IPerson => {
  return {
    ...rest,
    firstName: firstname,
    lastName: lastname,
  };
};
